import mailingList from './mailing-list';
import redirectToDashboard from './redirect-to-dashboard';

export { mailingList, redirectToDashboard };
